import { render, staticRenderFns } from "./SprayShipoStones.vue?vue&type=template&id=d71a0fde&scoped=true&"
import script from "./SprayShipoStones.vue?vue&type=script&lang=js&"
export * from "./SprayShipoStones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71a0fde",
  null
  
)

export default component.exports